import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchSensorInfo } from "../../../api/sensorApi";


function useFetchSensorInfo(sensorID, ratingUpdated) {
    const [infopanel_data, setInfopanel_data] = useState();
    //const [train_period, setTrainPeriod] = useState();
    useEffect(() => {
        fetchSensorInfo(sensorID).then((data) => {
            setInfopanel_data(data[0]);
            //setTrainPeriod(data.objs[0].corrosionRateLiveModel.trainInput);
        }).catch((error) => {
            console.log(error)
            toast.error("Error fetching sensor data")
        });
    }, [sensorID, ratingUpdated]);


    return {
        infopanel_data,
        //train_period
    }

}


export default useFetchSensorInfo;